import { render, staticRenderFns } from "./ClinicItemsIncomeReport.vue?vue&type=template&id=2d4563a1"
import script from "./ClinicItemsIncomeReport.vue?vue&type=script&lang=js"
export * from "./ClinicItemsIncomeReport.vue?vue&type=script&lang=js"
import style0 from "./ClinicItemsIncomeReport.vue?vue&type=style&index=0&id=2d4563a1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports